import 'regenerator-runtime/runtime';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import rootReducer from './reducers';

import rootSaga from './saga/rootSaga';
// const persistedData= localState();
const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware, createLogger(), ReduxThunk];
const composerEnhancers = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE_ || compose;
export default(initialState) => {
  const store = createStore(rootReducer, initialState, composerEnhancers(applyMiddleware(...middleware)));
  sagaMiddleware.run(rootSaga);
  // store.subscribe(()=>{
  //     saveState({
  //
  //         token :store.getState().auth[0].authHeader
  //     })
  // });
  return store;
};



// WEBPACK FOOTER //
// ./src/configurestore.js